import { Button, DataSource, Layout, Panel, Switch } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommControlManagement extends Layout {
    buttonDriverGoals: Button;
    buttonLogDetailLevel: Button;
    buttonMessageHistory: Button;
    buttonPositionHistory: Button;
    panelManagementNavigation: Panel;
    panelManagementOptions: Panel;
    sourceMCControl: DataSource;
    switchAddPositionOdometer: Switch;
    switchAutoConfirm: Switch;
    switchConvertTimeZone: Switch;
    switchWorkflowAcceptReject: Switch;
}
